import { DataBean } from "../DataBean";


export class ProjectID extends DataBean {

    public async getFunctionalIDByKey(idlnOProject: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.project.ProjectID_getProjectIDByKey_Number", [idlnOProject]);
    }


    public async getProjectModificationReport(idEmployee: number, idProject: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getProjectModificationReport_Number_Number", [idEmployee, idProject]);
    }

}